module.exports = __webpack_public_path__ + "media/images/common/order_limit-9887ebfcb76cf6e0b2db8692063d865f.png";